function watchWishlistButton() {
  console.log('Starting watchWishlistButton...');

  let buttonObserver = null;
  let ariaObserver = null;
  let currentButton = null;
  let anchor = null;

  function updateAnchor(btn) {
    const currentLabel = btn.getAttribute('aria-label');
    console.log('Current aria-label:', currentLabel);

    if (currentLabel === 'Remove from wishlist') {
      if (!anchor) {
        console.log('Creating "View Favorites" link');
        anchor = document.createElement('a');
        anchor.href = '/pages/favorites';
        anchor.textContent = 'Browse Favorites';
        anchor.style.cssText = 'margin-left: 1em; color: #41a4c1; text-decoration: underline; font-size: 14px;';
        anchor.setAttribute('data-wishlist-link', 'true');
        btn.insertAdjacentElement('afterend', anchor);
      }
    } else if (anchor) {
      console.log('Removing "View Favorites" link');
      anchor.remove();
      anchor = null;
    }
  }

  function watchButtonChanges(btn) {
    console.log('Setting up aria-label observer for button:', btn);

    // Clean up existing observer
    if (ariaObserver) {
      ariaObserver.disconnect();
    }

    currentButton = btn;

    // Initial check
    updateAnchor(btn);

    // Watch for aria-label changes
    ariaObserver = new MutationObserver(function (mutations) {
      console.log('Button mutation observed:', mutations);
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
          console.log('aria-label changed from', mutation.oldValue, 'to', btn.getAttribute('aria-label'));
          updateAnchor(btn);
        }
      });
    });

    ariaObserver.observe(btn, {
      attributes: true,
      attributeFilter: ['aria-label'],
      attributeOldValue: true,
    });
  }

  function findButton() {
    // Look for the wishlist button
    const btn = document.querySelector('.xb-wishlist-button button[aria-label]');

    if (btn && btn !== currentButton) {
      console.log('Found new wishlist button:', btn);
      watchButtonChanges(btn);
    }
  }

  // Initial search
  findButton();

  // Watch for the button to be added to the DOM
  buttonObserver = new MutationObserver(function (mutations) {
    let shouldCheck = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          // Check if the added node is the wishlist button or contains it
          if (
            node.classList?.contains('xb-wishlist-button') ||
            node.querySelector?.('.xb-wishlist-button') ||
            node.matches?.('button[aria-label]') ||
            node.querySelector?.('button[aria-label]')
          ) {
            shouldCheck = true;
          }
        }
      });
    });

    if (shouldCheck) {
      console.log('DOM changes detected, checking for wishlist button...');
      setTimeout(findButton, 100); // Small delay to ensure DOM is settled
    }
  });

  // Start observing the entire document for new buttons
  buttonObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  console.log('Wishlist button watcher initialized');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchWishlistButton);
} else {
  watchWishlistButton();
}